// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable no-restricted-imports, init-declarations, babel/camelcase, prefer-destructuring, no-implicit-coercion */
// FIXME: remove this disable directive and fix the ESLint error(s)

// @ts-expect-error: Flow to TS migration.
import _ from "lodash"
import moment from "moment"
import Customer from "@kiwicom/frontend-app/scripts/containers/mutable/Customer"
import type { DocumentNeed } from "@kiwicom/frontend-common/services/document/mapperDocumentNeed"
import mapperDocumentNeed from "@kiwicom/frontend-common/services/document/mapperDocumentNeed"
import mapperJourney from "@kiwicom/frontend-common/services/journey/mapperJourney"
import mapperInfantsConditions from "@kiwicom/frontend-common/services/infants/mapperInfantsConditions"
import { getAirlines } from "@kiwicom/frontend-common/services/staticData"
import type { Airlines } from "@kiwicom/frontend-common/records/Airline"

import Booking from "../../../../../../records/Booking"
import { ADDITIONAL_SERVICES_ALLOWED_TO_CHANGE_CONFIG } from "../../../../../../consts/additionalServices"
import mapperAdditionalServices from "./services/mapperAdditionalServices"
import mapperBookingPendingRefunds from "./services/mapperBookingPendingRefunds"
import mapperDisplayStatus from "./services/mapperDisplayStatus"
import mapperFlightsHistory from "./services/mapperFlightsHistory"
import mapperPendingFlightChangeOptions from "./services/mapperPendingFlightChangeOptions"
import mapperPendingRequests from "./services/mapperPendingRequests"
import mapperPassengers from "./services/mapperPassengers"
import mapperRefundMethods from "./services/mapperRefundMethods"
import type { BookingInput } from "../../../../../../records/bookingInput"
import mapperBookingRequests from "./services/mapperBookingRequests"
import mapperBaggages from "./services/mapperBaggages"
import mapperPayment from "./services/mapperPayment"
import mapperCheckIn from "./services/mapperCheckIn"
import type { Hours } from "../../../../../../types/primitiveTypes"
import { mapperBookingStatus } from "./services/mapperBookingStatus"
import { mapperGuarantee } from "./services/mapperGuarantee"
import mapperRefundOffers from "./services/mapperRefundOffers"
import mapperReservationsDetails from "./services/mapperReservationsDetails"
import mapperPartnerType from "./services/mapperPartnerType"

const COMPLETION_REAL_DEADLINE = 24

export type Config = {
  allowedToChangeSegments: boolean
  allowedToChangeItinerary: boolean
  allowedToChange: {
    // all values in hours
    additionalServices: Hours
    bags: Hours
    flights: Hours
    insuranceAdd: Hours
    insuranceChange: Hours
    other: Hours
    documents: Hours
    assistedRefund: Hours
    passengers: Hours
  }
  document: {
    need: DocumentNeed
  }
}

export default function mapperManageBooking(
  input: BookingInput,
  // NOTE!!!
  // This is a terrible idea and only here as a god damn hotfix
  // If I see anyone else doing this shit he's gonna have to explain himself
  // in front of every FE dev eye to eye as a shaming ritual
  // @ts-expect-error: Flow to TS migration.
  airlines: Airlines = getAirlines(window.__INITIAL_STATE__),
): Booking {
  // TODO: Use in more conditions, all data doesn't need to be parsed on account overview
  const isFullInput = typeof input.config !== "undefined"
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const assets: Record<string, any> = {}
  assets.boardingPasses =
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, @typescript-eslint/prefer-optional-chain
    input.assets && input.assets.boarding_passes ? input.assets.boarding_passes : {}
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, @typescript-eslint/prefer-optional-chain
  assets.eticket = input.assets && input.assets.eticket
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, @typescript-eslint/prefer-optional-chain
  assets.transferTicket = input.assets && input.assets.transfer_ticket
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, @typescript-eslint/prefer-optional-chain
  assets.insurance = input.assets && input.assets.insurance

  // @ts-expect-error: Flow to TS migration.
  const journey = mapperJourney(input, "", false, airlines)
  // @ts-expect-error: Flow to TS migration.
  const journeyWithHidden = mapperJourney(input, "", true, airlines)

  const customer = new Customer({
    phone: input.contact.phone,
    email: input.contact.email,
    pid: input.contact.pid,
  })

  // todo: remove
  const infantsConditions = mapperInfantsConditions(input.infants_conditions)

  const passengers = mapperPassengers(
    input.passengers,
    input.infants_conditions
      ? infantsConditions.get("handWeight") > 0
      : // @ts-expect-error: Flow to TS migration.
        journey.handBagsAllowedForInfants(), // keep backward compatibility
  )

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const actions: Record<string, any> = {}
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (input.assets) {
    actions.rateLow = input.assets.lowRating
    actions.rateHigh = input.assets.highRating
    actions.fillDetails = input.assets.documentDetails
  }

  let config
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (input.config) {
    config = {
      allowedToChangeSegments: input.config.allowed_to_change_segments,
      allowedToChangeItinerary: input.config.allowed_to_change_itinerary,
      allowedToChange: {
        // all values in hours
        bags: input.config.allowed_to_change.bags,
        flights: input.config.allowed_to_change.flights,
        insuranceAdd: input.config.allowed_to_change.insurance_add,
        insuranceChange: input.config.allowed_to_change.insurance_change,
        other: input.config.allowed_to_change.other,
        assistedRefund: input.config.allowed_to_change.assisted_refund,
        documents: COMPLETION_REAL_DEADLINE, // temporarily hardcoded --- input["config"]["allowed_to_change"]["documents"],
        additionalServices: ADDITIONAL_SERVICES_ALLOWED_TO_CHANGE_CONFIG,
        passengers: input.config.allowed_to_change.passengers,
      },
      document: {
        need: mapperDocumentNeed(input.document_options.document_need),
      },
    }
  }

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/array-type, @typescript-eslint/no-explicit-any
  let pendingRefunds: Array<any> | Array<never> = []
  if (_.isArray(input.pending_refunds)) {
    pendingRefunds = mapperBookingPendingRefunds(input.pending_refunds)
  }

  // TODO: temporary, until we agree with backend
  let insurancePricing
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (input.insurance_price) {
    insurancePricing = {
      travel_basic: input.insurance_price.travel_basic,
      travel_plus: input.insurance_price.travel_plus,
    }
  }

  // voluntary only
  let refundOptions
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (input.refundable_options) {
    refundOptions = {
      requested: input.refundable_options.requested
        ? moment.utc(input.refundable_options.requested * 1000)
        : null,
      validUntil:
        input.refundable_options.refundable_until &&
        moment.utc(input.refundable_options.refundable_until * 1000),
    }
  } else {
    refundOptions = {
      requested: null,
      validUntil: null,
    }
  }

  // grace period only
  let refundOption
  if (_.isArray(input.refund_options)) {
    refundOption = input.refund_options.map((x) => ({
      validUntil: moment.utc(x.valid_until * 1000),
    }))[0]
  } else {
    refundOption = null
  }

  // Billing details data
  let billingDetails
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (input.billing_details) {
    billingDetails = {}
    Object.keys(input.billing_details).forEach((k) => {
      // @ts-expect-error: Flow to TS migration.
      billingDetails[_.camelCase(k)] = input.billing_details[k]
    })
  }

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  const blockers = input.blockers || []

  return new Booking({
    id: input.bid,
    created: input.created * 1000,
    status: mapperBookingStatus(input.status, blockers),
    displayStatus: mapperDisplayStatus(input.display_status),
    blockers,
    blocked: input.blocked,
    ticketing_allowed: input.ticketing_allowed,
    authToken: input.auth_token,
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    additionalContacts: input.additional_contacts || [],
    config,
    journey,
    journeyWithHidden,
    guarantee: mapperGuarantee(input.guarantee),
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    bookingChanges: mapperBookingRequests(input.passenger_changes) || [],
    insurancePricing,
    isPassthroughBooking: Boolean(input.is_passthrough),
    flightsHistory: mapperFlightsHistory(input.flights_history),
    additionalServices: mapperAdditionalServices(input),
    pendingFlightChangeOptions: mapperPendingFlightChangeOptions(
      input.pending_flight_changes,
      airlines,
    ),
    pendingRequests: mapperPendingRequests(input.pending_requests),
    bags: input.bags,
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    baggages: mapperBaggages(input.baggages, input?.blueribbon_bags),
    actions,
    assets,
    customer,
    passengers,
    infantsConditions,
    sandbox: !!input.sandbox,
    payment: isFullInput
      ? mapperPayment({
          original_price: input.original_price,
          credits_payment: input.credits_payment,
          card_payment: input.card_payment,
          original_currency: input.original_currency,
          price: input.price,
        })
      : undefined, // Undefined is absence of evidence
    cancelRequested: input.cancel_requested ? input.cancel_requested * 1000 : null,
    pendingRefund: pendingRefunds.filter(
      // temporary calculator condition - remove after
      (x) => x.status === "pending" && x.reason !== "voluntary",
    )[0],
    refundOption, // grace period only
    refundOptions, // voluntary cancellation only
    refundMethods: mapperRefundMethods(input.refund_methods),
    billingDetails,
    checkIn: mapperCheckIn(
      input.checkin,
      // @ts-expect-error: Flow to TS migration.
      journeyWithHidden.getSegmentIdsWithHiddenCitiesInCombination(),
    ),
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    refundOffers: mapperRefundOffers(input.refund_offers ?? []),
    reservationsDetails: mapperReservationsDetails(input.reservations_details),
    partnerType: mapperPartnerType(input.partner_type),
  })
}
